const emailRegex =
  /* eslint-disable-next-line no-useless-escape */
  /^([a-zA-Z0-9_\+\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i;

export const validateEmailAddress = (email: string): boolean => {
  return emailRegex.test(email);
};
